import { ShiftTimeResponse } from '../../../api';

export const INITIAL_TIME_SHIFTS_VALUE: ShiftTimeResponse[] = [
  { type: 'fd', startTime: '-', endTime: '-', break: 0 },
  { type: 'zd', startTime: '-', endTime: '-', break: 0 },
  { type: 'sd', startTime: '-', endTime: '-', break: 0 },
  { type: 'nd', startTime: '-', endTime: '-', break: 0 },
];
